import { clearGroupArms, updateOrArm } from '~/hooks/aiSearchFilterEdits';
export const armChipTestIds = (arm, index)=>({
        Status: arm.Status(index),
        PaymentMethod: arm.PaymentMethod(index),
        AmendmentStatus: arm.AmendmentStatus(index),
        HasCredit: arm.HasCredit(index),
        EffectiveDate: arm.EffectiveDate(index),
        ApprovalDate: arm.ApprovalDate(index),
        ClientName: arm.ClientName(index),
        AgreementTitle: arm.AgreementTitle(index),
        ContactName: arm.ContactName(index),
        Assignee: arm.Assignee(index),
        ModifiedBy: arm.ModifiedBy(index),
        LastBilled: arm.LastBilled(index),
        Services: arm.Services(index),
        BundleName: arm.BundleName(index),
        Settings: arm.Settings(index),
        OrGroup: arm.OrGroup(index)
    });
export const nestedGroupActions = (arm, index, onArmChange)=>{
    const apply = (next)=>{
        if (next !== undefined) onArmChange(index, next !== null && next !== void 0 ? next : undefined);
    };
    return {
        onArmChange: (nestedIndex, nestedArm)=>apply(updateOrArm(arm, nestedIndex, nestedArm)),
        onClearGroup: ()=>apply(clearGroupArms(arm))
    };
};
